import React from 'react';
import { Box, Button, Text } from 'pcln-design-system';
const RealTimeVoiceModalInfo = ({
  onContinue
}) => {
  return React.createElement(Box, {
    padding: 3
  }, React.createElement(Text, {
    color: 'text.heading',
    fontSize: '26px',
    lineHeight: '32px',
    fontWeight: 'bold'
  }, "Penny Voice. Now with real-time, natural conversations."), React.createElement(Text, {
    mt: 4,
    fontSize: 1
  }, "Searching for hotels or updating your travel plans is now easier than ever with Penny Voice."), React.createElement(Text, {
    mt: 4,
    fontSize: 1
  }, ' ', "Enjoy real-time responses, the ability to interrupt anytime, and smooth, personalized interactions that adapt to your needs.", ' '), React.createElement(Text, {
    mt: 4,
    fontSize: 1
  }, ' ', "Ready to experience the future of travel assistance? Try Penny Voice today and see how effortless and fun travel planning can be!"), React.createElement(Button, {
    width: 1,
    mt: 4,
    onClick: onContinue
  }, "Continue"));
};
export default RealTimeVoiceModalInfo;